import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsPage: React.FC = () => (
  <>
    <Helmet>
      <title>Terms of Service | VB Entreprise | Premium IT & Digital Marketing Agency for US, UK & Canada Businesses</title>
    </Helmet>
    <div className="max-w-3xl mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-6">Terms of Service</h1>
      <p className="text-gray-700 mb-6">
        These Terms of Service ("Terms") govern your use of the website and services provided by <strong>VB Unified Entreprise OPC Private Limited</strong> ("we", "us", or "our"). By accessing or using our site, you agree to these Terms.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">1. Use of Our Services</h2>
      <ul className="list-disc ml-6 text-gray-700 mb-4">
        <li>You must be at least 18 years old to use our services.</li>
        <li>You agree to provide accurate and complete information.</li>
        <li>You are responsible for maintaining the confidentiality of your account.</li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">2. Intellectual Property</h2>
      <ul className="list-disc ml-6 text-gray-700 mb-4">
        <li>All content, trademarks, and intellectual property on this site belong to VB Unified Entreprise OPC Private Limited or its licensors.</li>
        <li>You may not copy, reproduce, or distribute any content without permission.</li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">3. Prohibited Conduct</h2>
      <ul className="list-disc ml-6 text-gray-700 mb-4">
        <li>No unlawful, harmful, or abusive use of our services.</li>
        <li>No interference with the security or integrity of our systems.</li>
        <li>No unauthorized access to other users' data.</li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">4. Disclaimers & Limitation of Liability</h2>
      <ul className="list-disc ml-6 text-gray-700 mb-4">
        <li>Our services are provided "as is" without warranties of any kind.</li>
        <li>We are not liable for any indirect, incidental, or consequential damages.</li>
        <li>We do not guarantee uninterrupted or error-free service.</li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">5. Changes to Terms</h2>
      <p className="text-gray-700 mb-4">
        We may update these Terms from time to time. The latest version will always be posted on this page. Continued use of our services constitutes acceptance of the updated Terms.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">6. Governing Law</h2>
      <p className="text-gray-700 mb-4">
        These Terms are governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of the courts in India.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">7. Contact</h2>
      <p className="text-gray-700">
        For questions about these Terms, please contact us at <a href="mailto:contact@vb-entreprise.com" className="text-jordy-blue-600 underline">contact@vb-entreprise.com</a>.<br/>
        <span className="block mt-2">VB Unified Entreprise OPC Private Limited</span>
      </p>
    </div>
  </>
);

export default TermsPage; 